<template>
  <div class="container">
    <div class="header clearfix">
      <h1 class="">Search</h1>
      <ul class="list-group">
        <li class="list-group-item well p-2">
          <b-form-select
            v-model="search_school"
            :options="schools_list"
            :disabled="search_destination_code ? true : false"
            class="mt-2"
            @change="search_destination_code = ''"
          ></b-form-select>
          <b-form-select
            v-model="search_suburb"
            :options="suburbs_list"
            :disabled="search_destination_code ? true : false"
            class="mt-2"
            @change="search_destination_code = ''"
          ></b-form-select>

          <search-input
            :disabled="search_school || search_suburb ? true : false"
            @input="
              (value) => {
                search_destination_code = value;
              }
            "
            @search="search_desto"
            title="Destination Code"
            v-model="search_destination_code"
          />

          <b-button
            class="mt-2 searchBtn"
            variant="dark"
            :disabled="
              (search_school && search_suburb) || search_destination_code != ''
                ? false
                : true
            "
            @click.prevent="
              getSearchResults(
                search_school,
                search_suburb,
                search_destination_code
              );
              notes();
            "
            block
          >
            Search
          </b-button>
        </li>
      </ul>

      <search-result
        v-if="show_results"
        :trips="trips"
        :suburb_notes="suburb_notes"
        :suburb="search_suburb"
        :school="search_school"
        @resetFields="resetFields"
      />
    </div>
  </div>
</template>

<script>
import SearchInput from "../components/SearchInput";
import SearchResult from "../components/SearchResult.vue";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "Home",
  components: {
    SearchInput,
    SearchResult,
  },
  computed: {
    ...mapState(["schools", "suburbs", "trips", "show_results"]),
    schools_list() {
      return [
        { value: null, text: "Select School" },
        ..._.sortBy(
          _.map(this.schools, (val) => {
            return {
              value: val.id,
              text: val.name,
            };
          }),
          ["text"]
        ),
      ];
    },
    suburbs_list() {
      return [
        { value: null, text: "Select Suburb" },
        ..._.sortBy(
          _.map(this.suburbs, (val) => {
            return {
              value: val.id,
              text: val.name,
            };
          }),
          ["text"]
        ),
      ];
    },
  },
  data() {
    return {
      search_school: null,
      search_suburb: null,
      search_destination_code: "",
      suburb_notes: "",
    };
  },
  mounted() {
    this.$store.dispatch("fetchSchools");
    this.$store.dispatch("fetchSuburbs");
  },
  methods: {
    search_desto(value) {
      this.getSearchResults(null, null, value);
    },
    getSearchResults(school, suburb, destination_code) {
      if (school && suburb) {
        this.$store.dispatch("fetchResultsBySchoolSuburb", { school, suburb });
      } else if (destination_code) {
        this.$store.dispatch("fetchResultsByDestination", destination_code);
      }
    },
    resetFields() {
      this.search_school = null;
      this.search_suburb = null;
      this.search_destination_code = "";
      this.suburb_notes = "";
    },
    notes() {
      this.suburb_notes = this.search_suburb
        ? _.find(this.suburbs, { id: this.search_suburb }).notes
        : "";
    },
  },
};
</script>

<style>
.searchBtn {
  /*background: #fffc0d;*/
  /*border: #f9ffbd;*/
}
</style>
